export enum FreespinsRewardType {
  REAL_MONEY = 'real_money',
  ROLLOVER_BONUS = 'rollover_bonus',
}
